<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :search-input.sync="search"
    :items="items"
    item-text="name"
    item-value="id"
    :loading="loading"
    clearable
    v-bind="$attrs"
    v-on="$listeners"
  )
</template>

<script>
import { getRegions } from '@/services/API/_common';

export default {
  props: {
    value: { type: [Object, Number], default: null },
    query: { type:Object, required:false, default: () => {} },
  },
  data() {
    return {
      model: null,
      search: null,
      items: [],
      loading:true,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    search() {
      // Items have already been requested
      if (this.loading) return;
      if (this.inputValue) return;
      this.loading = true;

      // Lazily load input items
      this.fetchRegions();
    },
    inputValue(val) {
      if (val) {
        this.$emit('change');
      }
    },
  },
  created() {
    this.fetchRegions();
  },
  methods:{
    fetchRegions() {
      const params = {
        // 'search[name]': this.search,
        'per-page': -1,
        ...this.query,
      };
      getRegions(params).then((response) => {
        this.items = response.data.data;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
